define("settings/routes/users/new", ["exports", "@ember/routing/route", "@ember/service", "ember-concurrency-decorators", "later/utils/time-format"], function (_exports, _route, _service, _emberConcurrencyDecorators, _timeFormat) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let NewRoute = (_class = class NewRoute extends _route.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "router", _descriptor4, this);

      _initializerDefineProperty(this, "segment", _descriptor5, this);

      _initializerDefineProperty(this, "settings", _descriptor6, this);

      _initializerDefineProperty(this, "store", _descriptor7, this);
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    model() {
      return this.store.createRecord('user', {
        account: this.currentAccount,
        createdTime: (0, _timeFormat.timestamp)()
      });
    }

    redirect() {
      var _this$auth$currentUse;

      if (!((_this$auth$currentUse = this.auth.currentUserModel) !== null && _this$auth$currentUse !== void 0 && _this$auth$currentUse.canAddUser)) {
        this.router.transitionTo('account.users');
      }
    }

    setupController(controller, model) {
      var _this$currentAccount$, _this$auth$currentUse2;

      const {
        users
      } = this.modelFor('users');
      const userCount = users.length;
      const totalUsers = (_this$currentAccount$ = this.currentAccount.totalUsers) !== null && _this$currentAccount$ !== void 0 ? _this$currentAccount$ : 1;
      let availableSeats = totalUsers - userCount;
      availableSeats = availableSeats > 0 ? availableSeats : 0;
      controller.setProperties({
        user: model,
        handleSubmit: this.handleSubmit,
        handleClose: this.handleClose,
        availableSeats,
        isAdmin: (_this$auth$currentUse2 = this.auth.currentUserModel) === null || _this$auth$currentUse2 === void 0 ? void 0 : _this$auth$currentUse2.admin
      });
    }

    *handleSubmit(_ref) {
      let {
        email,
        name
      } = _ref;

      try {
        const userInvite = this.currentAccount.invite({
          email,
          name
        });
        const {
          alert,
          response
        } = yield this.settings.submitForm.perform(userInvite, 'account.users.new', {
          email
        }); // Deletes unsaved user record

        this.store.peekAll('user').findBy('id', null).unloadRecord();
        this.alerts.add(alert);
        this.segment.track('added-team-member', {
          team_member_id: response.id,
          team_member_email: response.email
        });
        this.send('handleUpdate'); // Refreshes the parent route to display the new user

        this.router.transitionTo('account.users');
      } catch ({
        alert
      }) {
        alert.message = this.intl.t('account.users.new.error.message', {
          email
        });
        alert.timeout = 5000;
        this.alerts.add(alert);
      }
    }

    *handleClose(user) {
      const condition = user.isNew && (user.email || user.name) || !user.isNew && user.hasDirtyAttributes;
      yield this.settings.confirmClose(condition);
      user.rollbackAttributes();
      this.router.transitionTo('account.users');
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "handleSubmit", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "handleSubmit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClose", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "handleClose"), _class.prototype)), _class);
  _exports.default = NewRoute;
});